import React from 'react';
import { SelectDate } from './SelectDate';
import { SelectDownload } from './SelectDownload';
import { SelectEndHours } from './SelectEndHours';
import { SelectLog } from './SelectLog';
import { SelectStartHours } from './SelectStartHours';

const panelStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 36
};
const leftPanelStyle = {
    ...panelStyle,
    flexGrow: 1
};
const rightPanelStyle = {
    ...panelStyle
};
const titleStyle = {
    color: '#414141',
    fontSize: 28,
    fontWeight: 'bold',
    height: 55
};

export const SelectionPanel = () => {
    return (
        <div style={panelStyle}>
            <div style={leftPanelStyle}>
                <div style={titleStyle}>{window.translate('Live Content Day Report')}</div>
            </div>
            <div style={rightPanelStyle}>
                <SelectLog />
                <SelectDate />
                <SelectStartHours />
                <SelectEndHours />
                <SelectDownload />
            </div>
        </div>
    );
};
